"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _HBTabs = require("./HBTabs.styles");
var _DotsVertical = _interopRequireDefault(require("@honeybook/icons/dist/icons/DotsVertical12"));
var _HBMenu = _interopRequireDefault(require("../HBMenu/HBMenu"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _useEllipsis3 = _interopRequireDefault(require("../common/useEllipsis"));
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TabItem = function TabItem(_ref) {
  var hasMenu = _ref.hasMenu,
    isActive = _ref.isActive,
    isIconOnly = _ref.isIconOnly,
    maxTabWidth = _ref.maxTabWidth,
    onClick = _ref.onClick,
    renderTab = _ref.renderTab,
    scrollRef = _ref.scrollRef,
    selectedHighlightColor = _ref.selectedHighlightColor,
    size = _ref.size,
    stretchToFill = _ref.stretchToFill,
    tab = _ref.tab,
    LinkComponent = _ref.LinkComponent;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isMenuOpen = _useState2[0],
    setIsMenuOpen = _useState2[1];
  var tabContainerRef = (0, _react.useRef)(null);
  var _useEllipsis = (0, _useEllipsis3["default"])({
      textValue: tab.title
    }),
    _useEllipsis2 = (0, _slicedToArray2["default"])(_useEllipsis, 2),
    tabTextRef = _useEllipsis2[0],
    isOverflowing = _useEllipsis2[1];
  var textType = _HBTabs.tabTitleStyle[size][isActive ? 'active' : 'notActive'];
  var tabTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    identifier: tab.testId || tab.id,
    suffix: 'tab',
    componentName: 'HBTabs'
  });
  (0, _react.useEffect)(function () {
    var scrollContainer = scrollRef.current;
    var tabContainer = tabContainerRef.current;
    if (!isActive || !scrollContainer || !tabContainer) {
      return;
    }
    var scrollLeft = tabContainer.offsetLeft - (scrollContainer.clientWidth - tabContainer.clientWidth) / 2;
    scrollContainer.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  }, [isActive, tab.title, tabTextRef, tab, scrollRef]);
  var handleClick = function handleClick(ev) {
    var _ev$currentTarget;
    ev === null || ev === void 0 || (_ev$currentTarget = ev.currentTarget) === null || _ev$currentTarget === void 0 || _ev$currentTarget.blur();
    if (!tab.isDisabled && onClick) {
      onClick(tab.id);
    }
  };
  if (renderTab) {
    return renderTab(_objectSpread(_objectSpread({}, tab), {}, {
      isActive: isActive,
      onClick: handleClick
    }));
  }

  // Base props common to both link and button tabs
  var tabInteractionProps = {
    onClick: handleClick
  };
  if (tab.to && !LinkComponent) {
    throw new Error('HBTabs: `tab.to` was provided, but no `LinkComponent` was found in HBUIProvider context. Please wrap your app in HBUIProvider and provide a LinkComponent.');
  }
  if (LinkComponent && tab.to) {
    tabInteractionProps.as = LinkComponent;
    tabInteractionProps.to = tab.to;
    tabInteractionProps['aria-current'] = isActive ? 'page' : undefined;
    tabInteractionProps.style = {
      textDecoration: 'none',
      color: 'inherit'
    };
  }
  return /*#__PURE__*/_react["default"].createElement(_HBTabs.Tab, (0, _extends2["default"])({}, tabInteractionProps, {
    "data-is-active": isActive,
    $hasMenu: hasMenu,
    $isActive: isActive,
    isDisabled: tab.isDisabled,
    $isIconOnly: isIconOnly,
    $isMenuOpen: isMenuOpen,
    key: tab.id,
    $maxTabWidth: maxTabWidth,
    ref: tabContainerRef,
    $selectedHighlightColor: selectedHighlightColor,
    $stretchToFill: stretchToFill,
    testId: tabTestId
  }), tab.icon, tab.title && /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], {
    disabled: !isOverflowing,
    offsetY: 4,
    placement: "top",
    target: /*#__PURE__*/_react["default"].createElement(_HBTabs.TabTitle, {
      ref: tabTextRef,
      type: textType
    }, tab.title),
    targetContainerStyle: tooltipTargetContainerStyle
  }, tab.title), tab.suffix && /*#__PURE__*/_react["default"].createElement(_HBTabs.TabSuffixContainer, null, tab.suffix), tab.menuItems && /*#__PURE__*/_react["default"].createElement(_HBMenu["default"], {
    align: "start",
    menuItems: tab.menuItems,
    onOpenChange: setIsMenuOpen,
    preventClickPropogation: true,
    size: "md",
    target: /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
      buttonTheme: "subtle-invisible",
      icon: _DotsVertical["default"],
      isSelected: isMenuOpen,
      label: "tab-menu",
      size: "xxs",
      testId: "tab-menu-item"
    }),
    targetContainerStyle: menuTargetContainerStyle,
    testIdName: "tab-menu",
    withArrow: false
  }));
};
var _default = exports["default"] = TabItem; // -------------------------------- Styles -------------------------------- //
var tooltipTargetContainerStyle = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
};
var menuTargetContainerStyle = {
  transition: 'all 0.15s ease-in',
  position: 'absolute',
  opacity: 0,
  transform: 'translate(-50%, -50%)',
  marginLeft: '4px'
};
//# sourceMappingURL=TabItem.js.map